/**
 * @desc: - loading遮罩 
 * @param  {[bool]} display: [是否显示遮罩]
 * @param  {[string]} text : [icon下方文字]
 * @author: circle
 */
import React from 'react';
export default class SMALLLOADING extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let {display, text} = this.props;
    return (
      <div className="small-loading" style = {{display:display?"block":"none"}}>
        <p>{text}</p>
      </div>
    );
  }
}